window.dataLayer = window.dataLayer || [];

//track CTA clicks
const pageTitle = document.querySelector(".acc-page-title")?.innerText;

function trackCtaClicks(ctaList, event) {
    for (const cta of ctaList) {
        cta.addEventListener("click", () => {
            let ctaTitle = cta.querySelector("a")?.innerText;
            ctaTitle = ctaTitle ?? cta.innerText;
            const sectionTitle = cta.getAttribute("data-section-title");
            const cardTitle = cta.getAttribute("data-card-title");
            const tabTitle = cta.getAttribute("data-tab-title");

            if (cta.closest("section")?.classList.contains("adm-section-c25-content")
                && !cta.classList.contains("adm-bg-navy")) {
                window.dataLayer.push({
                    'event': event,
                    'page': pageTitle,
                    'section': sectionTitle,
                    'tab': tabTitle,
                    'card': cardTitle,
                    'title': ctaTitle
                });
            } else if (cardTitle) {
                window.dataLayer.push({
                    'event': event,
                    'page': pageTitle,
                    'section': sectionTitle,
                    'card': cardTitle,
                    'title': ctaTitle
                });
            } else {
                window.dataLayer.push({
                    'event': event,
                    'page': pageTitle ?? sectionTitle,
                    'section': sectionTitle,
                    'title': ctaTitle
                });
            }
        });
    }
}

const ctaButtons = document.querySelectorAll(`div.adm-btn`);
const ctaLinks = document.querySelectorAll(".adm-link-cta");

if (ctaButtons.length) trackCtaClicks(ctaButtons, "track-button");
if (ctaLinks.length) trackCtaClicks(ctaLinks, "track-link");